var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0591 3.09687L16.859 4.80377L6.3401 8.50441L5.89054 4.66908C5.84224 4.25702 6.06058 3.85713 6.45722 3.69992C8.09331 3.05147 11.4642 2.13662 16.0308 2.00047C16.648 1.98207 17.1287 2.50326 17.0591 3.09687Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5199 10.0386L16.6637 6.46991L15.6941 14.7419L6.97963 13.254C6.95152 13.2492 6.92349 13.246 6.89564 13.2442L6.5199 10.0386Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57004 18.9975L7.07746 14.7952L15.5031 16.2337L15.519 16.2362L15.1953 18.9975H16.1552C16.7265 18.9975 17.1897 19.4456 17.1897 19.9983V20.4988H18.2241C18.6526 20.4988 19 20.8348 19 21.2494C19 21.6639 18.6526 22 18.2241 22H4.77586C4.34737 22 4 21.6639 4 21.2494C4 20.8348 4.34737 20.4988 4.77586 20.4988H5.81034V19.9983C5.81034 19.4456 6.2735 18.9975 6.84483 18.9975H7.57004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy4);
export default __webpack_public_path__ + "static/media/trophy-4.4ebbc9bca125ce2a0cd6dbd73b162ec2.svg";
export { ForwardRef as ReactComponent };